import { csrfRequest } from './helpers/request'
import { GENERIC_RECOVERY_CODES_ERROR_CODE } from '../../constants/error.codes'

export const registerRecoveryOtps = () =>
  csrfRequest({
    url: '/users/mfa/otp'
  })
    .then(response => {
      if (response.status === 200) {
        return response.json().then(json => Promise.resolve(json))
      } else if (response.status === 403) {
        return response
          .json()
          .then(json => Promise.reject(new Error(json.code)))
      } else {
        return Promise.reject(new Error(GENERIC_RECOVERY_CODES_ERROR_CODE))
      }
    })
    .catch(error => {
      throw error
    })
